import { lang } from '@umu/ukit-lang';
import './bookDemoBanner.scss';
import React from 'react';
import { components } from 'common';
const { If, PreImg } = components;

interface IProp {
    referUrl: string;
    platform: 'twww' | 'mobile'; // 平台
}

export const BookDemoBanner = (props: IProp) => {
    return (
        <div
            className={
                props.platform === 'twww' ? 'contract-sales-banner' : 'contract-sales-banner contract-m-sales-banner'
            }
        >
            <If condition={props.platform === 'twww'}>
                <div className="section-head-img">
                    <PreImg>
                        <img className="user-img-twww" src={require(`./images/user.png`)} alt="" />
                    </PreImg>
                </div>
            </If>
            <If condition={props.platform === 'mobile'}>
                <PreImg>
                    <img className="user-img" src={require(`./images/user-m.png`)} alt="" />
                </PreImg>
            </If>
            <div className="contract-sales-container">
                <div className="title">{lang('预约演示')}</div>
                <div className="des">{lang('请填写表单，我们的销售会与您联系')}</div>
            </div>
        </div>
    );
};
